import '../css/eigen-timer-page.scss'

import './custom-timer.js'
import './global.js';
